module.exports = __webpack_public_path__ + "static/ceramics-porcelain-thumbnail-992d914df350e345d5a8570a5ee95674.jpg";